import { AppRecord, AppRecordStatus } from "models/appRecord";

import { useState } from "react";
import { useLocation } from "react-router-dom";
import { AppLog } from "services";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";
import Religion from "./dummyStaff";
type WorkingHour = {
  starting_time: string;
  ending_time: string;
  no_of_working_hour: string;
  no_of_break_minute: string;
  break_starting_time: string;
  break_ending_time: string;
};

type FormData = {
  shift_group_id: any;
  shop_id: any;
  local_description: string;

  latitude: string;
  longitude: string;
  max_distance: string;
  working_hours: WorkingHour[];
};
const { days } = Religion();

const StaffAction = () => {
  const { token } = useAppSelector((state) => state.auth);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const shopId = searchParams.get("id");
  const [isCreateStaff, setIsCreateStaff] = useState<boolean>(false);

  // -------------------------------------
  const [loadingDeleteShift, setLoadingDeleteShit] = useState<boolean>(false);
  // -------------state view card or table ui ---------------

  //   ------------------state employeee-----------------
  const [loadingfetchEmployee, setloadingfetchEmployee] = useState<boolean>(false);
  const [searchTextInput, setSearchTextInput] = useState<string>("");
  const [shopEmployee, setShopEmployee] = useState<any>(null);
  const [shopEmployeeLoading, setShopEmployeeLoading] = useState<any>(null);
  //   ------------------state Department-----------------
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [selectedLineManager, setSelectedLineManager] = useState<any>();
  const [departmentActive, setDepartmentActive] = useState<any>("");
  const [departmentName, setDepartmentName] = useState<any>();
  const [shiftActive, setShiftActive] = useState<any>();
  const [shiftGroupId, setShiftGroupId] = useState<any>();
  const [dob, setDob] = useState<any>();
  const [joinedDate, setJoinedDate] = useState<any>();
  const [probationDate, setProbationDate] = useState<any>();
  const [nationality, setNationality] = useState<any>();
  const [religion, setReligion] = useState<any>();
  const [loadingFetchDataDepartment, setLoadingFetchDataDepartment] = useState<boolean>(false);
  const [department, setDepartment] = useState<any>();
  const [alldepartment, setAllsetDepartment] = useState<any>();
  const [storage_host_cluster_Id, setStorage_host_cluster_Id] = useState<any>();

  const [userShopShiftGroup, setUserShopShiftGroup] = useState<any>();

  // ---------------emergency contact ---------------
  const [emergencyContact, setEmergencyContact] = useState({
    emergency_contact_name: "",
    emergency_contact_phone_no: "",
    emergency_contact_email: "",
  });

  // -------------personalInfo state------------
  const [personalInfo, setPersonalInfo] = useState({
    local_name: "",
    english_name: "",
    gender: "male",
    marital_status: "single",
    id_card_no: "",
    passport_no: "",
    phone_no: "",
    phone_no_2: "",
    email: "",
    address: "",
    permanent_address: "",
  });
  // ----------------JobInfo state------------------
  const [jobInfo, setJobInfo] = useState({
    card_no: "",
    attendance_card_no: "",
    nssf_no: "",
    position: "",
    basic_salary: "",
    end_probation_remark: "",
  });

  // -------------- function clear data ---------------
  const clearData = () => {
    setEmergencyContact({
      emergency_contact_name: "",
      emergency_contact_phone_no: "",
      emergency_contact_email: "",
    });

    setJobInfo({
      card_no: "",
      attendance_card_no: "",
      nssf_no: "",
      position: "",
      basic_salary: "",
      end_probation_remark: "",
    });

    setPersonalInfo({
      local_name: "",
      english_name: "",
      gender: "male",
      marital_status: "single",
      id_card_no: "",
      passport_no: "",
      phone_no: "",
      phone_no_2: "",
      email: "",
      address: "",
      permanent_address: "",
    });

    setDob("");
    setNationality("");
    setProbationDate("");
    setJoinedDate("");
    setReligion("");
    setDepartmentActive("");
    setSelectedLineManager("");
    setSelectedDayoff([]);
    // setSelectedShift([]);
  };
  //   ------------------fetch Department-----------------
  const [errorStatus, setErrorStatus] = useState({
    title: "",
    message: "",
  });
  const [warning, setWarning] = useState(false);

  const fetchDepartment = async () => {
    setLoadingFetchDataDepartment(true);
    try {
      const url = `${RouteApi.getShopDepartment}token=${token}`;
      const data = {
        shop_id: shopId,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        // console.log(response, "department");
        setAllsetDepartment(response["user_shop_departments"]);
        setStorage_host_cluster_Id(response.storage_host_cluster);
        // fetchDepartment();
        setDepartment(response["departments"]);
        setUserShopShiftGroup(response["user_shop_shift_groups"]);
        // console.log(response, "fetch Department---");
        setLoadingFetchDataDepartment(false);
      } else {
        setLoadingFetchDataDepartment(false);
        setErrorStatus({
          title: response.status,
          message: response.msg,
        });
        setWarning(true);
      }
    } catch (error: any) {
      setLoadingFetchDataDepartment(false);
      AppLog.show({
        message: `[fetchDepartment]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const toggleDayoffSelection = (dayOff: string) => {
    setSelectedDayoff(
      (prevSelected) =>
        prevSelected.includes(dayOff)
          ? prevSelected.filter((id) => id !== dayOff) // Remove if already selected
          : [...prevSelected, dayOff] // Add if not selected
    );
  };
  const [selectedDayoff, setSelectedDayoff] = useState<string[]>([]); // Store multiple selected printers

  // -------------------------fetch shop Employeee------------------
  const getShopEmployeeSearch = async () => {
    // console.log(department.description, "deparment");
    setloadingfetchEmployee(true);
    try {
      const url = `${RouteApi.getShopEmployeeSearch}token=${token}`;
      const data = {
        shop_id: shopId,
        search_text: searchTextInput,
        department: "",
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        // console.log("response data fetch shop employee ", response);
        console.log(response, "fetch shop employee search data");
        setloadingfetchEmployee(false);
        const stateRecord: AppRecord = {
          currentPage: 1,
          currentIndex: 0,
          nextPageUrl: response["user_shop_products"]["next_page_url"] ?? "",
          totalRecord: 0,
          loadingStatus: response["user_shop_products"]["next_page_url"] != null ? AppRecordStatus.loaded : AppRecordStatus.noLoadMore,
        };
        setShopEmployee(response["user_shop_employees"]["data"]);
        setShopEmployeeLoading(stateRecord);
      } else {
        console.log(response, "error fetch shop employee ");
      }
    } catch (error) {
      setloadingfetchEmployee(false);
      AppLog.show({
        message: `[getShopEmployeeSearch]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  //---------------------submit Create and Update staffs--------------------
  const [editEmloyeeId, setEditEmloyeeId] = useState<any>(null);

  const [loadingSubmitCreateUpdateStaff, setLoadingSubmitCreateUpdateStaff] = useState<boolean>(false);
  const onSubmitCreateAndUpdateStaff = async () => {
    setLoadingSubmitCreateUpdateStaff(false);
    const { local_name, english_name, gender, marital_status, id_card_no, passport_no, phone_no, email, address, permanent_address } = personalInfo;
    const { emergency_contact_name, emergency_contact_phone_no, emergency_contact_email } = emergencyContact;
    const { card_no, attendance_card_no, nssf_no, position, basic_salary, end_probation_remark } = jobInfo;
    try {
      // const url = `${RouteApi.submitInsertShopEmployee}token=${token}`;
      let url: string = "";
      url = isCreateStaff === true ? RouteApi.submitInsertShopEmployee : RouteApi.submitUpdateShopEmployee;
      url += `token=${token}`;
      const data = {
        employee_id: "",
        shop_id: shopId,
        employee: {
          // ---personalInfo--
          local_name,
          english_name,
          gender,
          date_of_birth: dob,
          marital_status,
          nationality,
          religion: religion,
          id_card_no,
          passport_no,
          phone_no,
          email,
          address,
          permanent_address,
          // -----mergency-------
          emergency_contact_name,
          emergency_contact_phone_no,
          emergency_contact_email,
          // -------job info --------
          card_no,
          attendance_card_no,
          nssf_no,
          position,
          basic_salary,
          end_probation_remark,
          probation_date: probationDate,
          joined_date: joinedDate,
          department: departmentName,
          shift_group_id: "",
          office_phone_no: "",
          phone_no_2: "",
          extension_no: "",
        },
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        console.log(response, "response success submit create ");
        // do somthing
        // setisDialogOpenAddAndEditStaff(false);
      } else {
        console.log("error onsubmit create and update");
      }
    } catch (error) {
      setLoadingSubmitCreateUpdateStaff(false);
    }
  };

  // ---------------------submit Delete-------------------
  const [loadingSubmitDelete, setLoadingSubmitDelete] = useState<boolean>(false);
  const onSubmitDelete = async () => {
    setLoadingSubmitDelete(true);
    try {
      const url = `${RouteApi.getShopEmployeeSearch}token=${token}`;
      const data = {
        shop_id: shopId,
        search_text: searchTextInput,
        department: "",
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setLoadingSubmitDelete(false);

        // do something
      } else {
        console.log("error delete");
      }
    } catch (error) {
      setLoadingSubmitDelete(false);
    }
  };

  // -------------------------calculateEndTime shift working--------------------------
  const calculateEndTime = (startTime: string, workingHours: string): string => {
    if (!startTime || !workingHours) return "";

    const [hours, minutes] = startTime.split(":").map(Number);
    const workHours = parseFloat(workingHours);

    if (isNaN(workHours) || workHours <= 0) return "";

    const endTime = new Date();
    endTime.setHours(hours);
    endTime.setMinutes(minutes);
    endTime.setMinutes(endTime.getMinutes() + workHours * 60); // Add working hours

    return endTime.toTimeString().slice(0, 5); // Format as HH:mm
  };
  const calculateBreakEndTime = (startTime: string, breakMinutes: string): string => {
    if (!startTime || !breakMinutes) return "";

    const [hours, minutes] = startTime.split(":").map(Number);
    const breakMins = parseInt(breakMinutes, 10);

    if (isNaN(breakMins) || breakMins <= 0) return "";

    const breakEnd = new Date();
    breakEnd.setHours(hours);
    breakEnd.setMinutes(minutes);
    breakEnd.setMinutes(breakEnd.getMinutes() + breakMins);

    return breakEnd.toTimeString().slice(0, 5); // Format as HH:mm
  };

  const [formData, setFormData] = useState<FormData>({
    shift_group_id: "",
    shop_id: shopId,
    local_description: "",
    latitude: "",
    longitude: "",
    max_distance: "",
    working_hours: days.map((day) => ({
      weekday: day,
      starting_time: "",
      ending_time: "",
      no_of_working_hour: "",
      no_of_break_minute: "",
      break_starting_time: "",
      break_ending_time: "",
    })),
  });
  // const handleChange = (index: number, field: keyof WorkingHour, value: string) => {
  //   const updatedHours = [...formData.working_hours];
  //   updatedHours[index][field] = value;

  //   if (field === "starting_time" || field === "no_of_working_hour") {
  //     updatedHours[index].ending_time = calculateEndTime(updatedHours[index].starting_time, updatedHours[index].no_of_working_hour);
  //   }

  //   setFormData({ ...formData, working_hours: updatedHours });
  // };
  // const handleChange = (index: number, field: keyof WorkingHour, value: string) => {
  //   let updatedHours = [...formData.working_hours];

  //   // If user edits index 0, apply value to all entries
  //   if (index === 0) {
  //     updatedHours = updatedHours.map((entry) => {
  //       const updated = { ...entry, [field]: value };

  //       // Auto-calculate ending_time if needed
  //       if (field === "starting_time" || field === "no_of_working_hour") {
  //         updated.ending_time = calculateEndTime(updated.starting_time, updated.no_of_working_hour);
  //       }

  //       return updated;
  //     });
  //   } else {
  //     // Normal update for individual day
  //     updatedHours[index] = {
  //       ...updatedHours[index],
  //       [field]: value,
  //     };

  //     if (field === "starting_time" || field === "no_of_working_hour") {
  //       updatedHours[index].ending_time = calculateEndTime(updatedHours[index].starting_time, updatedHours[index].no_of_working_hour);
  //     }
  //   }

  //   setFormData({ ...formData, working_hours: updatedHours });
  // };
  const handleChange = (index: number, field: keyof WorkingHour, value: string) => {
    let updatedHours = [...formData.working_hours];

    const updateEntry = (entry: WorkingHour): WorkingHour => {
      const updated = { ...entry, [field]: value };

      // Auto-calculate ending_time
      if (field === "starting_time" || field === "no_of_working_hour") {
        updated.ending_time = calculateEndTime(updated.starting_time, updated.no_of_working_hour);
      }

      // Auto-calculate break_ending_time
      if (field === "break_starting_time" || field === "no_of_break_minute") {
        updated.break_ending_time = calculateBreakEndTime(updated.break_starting_time, updated.no_of_break_minute);
      }

      return updated;
    };

    if (index === 0) {
      updatedHours = updatedHours.map(updateEntry);
    } else {
      updatedHours[index] = updateEntry(updatedHours[index]);
    }

    setFormData({ ...formData, working_hours: updatedHours });
  };

  const clearDatashift = () => {
    setFormData({
      shift_group_id: "",
      shop_id: shopId,
      local_description: "",
      latitude: "",
      longitude: "",
      max_distance: "",
      working_hours: days.map((day) => ({
        weekday: day,
        starting_time: "",
        ending_time: "",
        no_of_working_hour: "",
        no_of_break_minute: "",
        break_starting_time: "",
        break_ending_time: "",
      })),
    });
  };

  return {
    // -------shopEmployee-------
    shopEmployee,
    editEmloyeeId,
    setEditEmloyeeId,
    // ---------------
    calculateEndTime,
    clearDatashift,
    handleChange,
    formData,
    setFormData,

    // ---department---
    alldepartment,
    setAllsetDepartment,
    fetchDepartment,
    loadingFetchDataDepartment,
    department,
    // ----emerencyContact----
    emergencyContact,
    setEmergencyContact,
    // -----personalInfo------
    personalInfo,
    setPersonalInfo,
    jobInfo,
    setJobInfo,

    toggleDayoffSelection,
    selectedDayoff,
    setReligion,
    setNationality,
    setProbationDate,
    setJoinedDate,
    setDob,
    getShopEmployeeSearch,
    setSearchTextInput,
    searchTextInput,
    isCreateStaff,
    setIsCreateStaff,
    departmentActive,
    setDepartmentActive,
    setDepartmentName,
    clearData,
    selectedLineManager,
    setSelectedLineManager,
    // -----submit create update -------
    onSubmitCreateAndUpdateStaff,
    loadingSubmitCreateUpdateStaff,

    // ------submit delete ----------
    onSubmitDelete,
    loadingSubmitDelete,

    // -----shift------
    shiftGroupId,
    setShiftGroupId,
    loadingDeleteShift,
    setLoadingDeleteShit,
    shiftActive,
    setShiftActive,
    userShopShiftGroup,
    setUserShopShiftGroup,
    // -------
    isSuccess,
    setIsSuccess,
    storage_host_cluster_Id,
    errorStatus,
    setErrorStatus,
    warning,
  };
};

export default StaffAction;
